export default __webpack_public_path__ + "static/media/q16_v2.4e8b665d.png";